import React, { useEffect } from 'react';
import { getText } from '@storebrand-digital/fms-translations';
import {
  Illustration,
  IllustrationContainer,
  MainContainer,
  MainContent,
  PageContainer,
} from '@/styled';
import Button from '@storeblocks/button';
import Styled from './styled';

const NotFoundErrorPage = () => {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log("Write 'burn' if you want to see Storebrand on fire!");
  });

  return (
    <PageContainer>
      <MainContainer>
        <MainContent shouldShake={false}>
          <Styled.StatusCode>404</Styled.StatusCode>
          <Styled.StatusMesssage>{getText('title')}</Styled.StatusMesssage>
          <Styled.StatusDescription>
            {getText('description.normal')}
          </Styled.StatusDescription>
          <Button as="a" href={getText('goHome.button.href')}>
            {getText('goHome.button.title')}
          </Button>
        </MainContent>

        <IllustrationContainer shouldShake={false}>
          <Illustration />
        </IllustrationContainer>
      </MainContainer>
    </PageContainer>
  );
};

export default NotFoundErrorPage;
